import * as requests from '../api-request'

export const getProjects = async () => {
  return requests.toJSON('GET', 'shared_projects')
}

export const getSingleProject = async (projectUuid) => {
  return requests.toJSON('GET', `shared_projects/${projectUuid}`)
}

export const getSharedUsers = async (projectUuid) => {
  return requests.toJSON('GET', `shared_projects/${projectUuid}/shared_users`)
}

export const getScript = async (data) => {
  return requests.toJSON('GET', `shared_projects/${data.projectUuid}/script/${data.scriptUuid}`)
}

export const sendInvitation = async (data) => {
  return requests.toJSON('POST', 'shared_projects/invite_user', data)
}

export const getInvitations = async (data) => {
  const queryString = requests.createQueryString(data)
  return requests.toJSON('GET', `shared_projects/invitations?${queryString}`, data)
}

export const validateInvitation = async (data) => {
  return requests.toJSON('POST', 'shared_projects/validate_invitation', data)
}

export const deleteInvitation = async (data) => {
  return requests.toJSON('POST', 'shared_projects/delete_invitation', data)
}

export const updateShareAccess = async (data) => {
  return requests.toJSON('PUT', `shared_projects/${data.projectUuid}/share/${data.shareId}`, data)
}

export const deleteShareAccess = async (data) => {
  return requests.toJSON('DELETE', `shared_projects/${data.projectUuid}/share/${data.shareId}`)
}

export const leaveProject = async (data) => {
  return requests.toJSON('DELETE', `shared_projects/${data.projectUuid}`)
}
